'use client';
import React, { type ReactNode } from 'react';
import styles from './AfterCopyrightBar.module.scss';

interface AfterCopyrightBarProps {
  children?: ReactNode;
}

export const AfterCopyrightBar: React.FC<AfterCopyrightBarProps> = ({ children }) => {
  if (!children) {
    return null;
  }

  return <div className={styles.afterCopyrightBar}>{children}</div>;
};
